import React, { useEffect, useState } from 'react';
import { Button, Form, Modal, Spin } from 'antd';
import { observer } from 'mobx-react';
import EnquiryForm from './FormComponent';
import useStore from '../../../../store';
import { Notification } from '../../../../config/Global';
import Message from '../../../../config/Message';

const EditComponent = observer((props) => {
	const { visible, onClose } = props;

	const [form] = Form.useForm();

	const { ENQUIRY } = useStore();

	const { enquiryDetail } = ENQUIRY;

	const [disabled, setDisabled] = useState(true);
	const [saving, setSaving] = useState(false);

	const handleSubmit = async (data) => {
		setSaving(true);

		try {
			const response = await ENQUIRY.updateEnquiry({
				...data,
				id: enquiryDetail.id,
				versionNo: enquiryDetail.versionNo,
			});

			if (response.httpStatusCode === 200) {
				Notification.success({
					message: Message().CRUD.UPDATE('Enquiry'),
				});
			}

			closeModal();
		} catch (error) {
			Notification.error({
				message: 'Error Updating Enquiry',
			});
		} finally {
			setSaving(false);
		}
	};

	const handleChange = () => {
		setTimeout(() => {
			form.validateFields({ validateOnly: true })
				.then(() => {
					setDisabled(false);
				})
				.catch(() => {
					setDisabled(true);
				});
		}, 0);
	};

	const closeModal = () => {
		setDisabled(true);
		form.resetFields();
		ENQUIRY.enquiryDetail = null;
		onClose();
	};

	useEffect(() => {
		if (visible && enquiryDetail) {
			form.setFieldsValue({
				enquiryType: enquiryDetail.enquiryType,
				name: enquiryDetail.name,
				mobileNumber: enquiryDetail.mobileNumber,
				email: enquiryDetail.email,
				city: enquiryDetail.city,
				propertyName: enquiryDetail.propertyName,
				description: enquiryDetail.description,
				tourPackageId: enquiryDetail.tourPackageId,
				price: enquiryDetail.price,
				packageName: enquiryDetail.packageName,
				noOfAdult: enquiryDetail.noofAdult,
				title:enquiryDetail.title,
				enquiryStatus:enquiryDetail.enquiryStatus,
				preferredDate:enquiryDetail.preferredDate
			});
		}
	}, [visible, enquiryDetail]);

	return (
		<Modal
			title="Edit Enquiry"
			onCancel={closeModal}
			open={visible}
			destroyOnClose
			width={'900px'}
			footer={
				<div>
					<Button
						type="primary"
						key={1}
						disabled={disabled}
						htmlType="submit"
						loading={saving}
						form="EditEnquiryForm"
					>
						Update Enquiry
					</Button>

					<Button key={2} onClick={closeModal}>
						Cancel
					</Button>
				</div>
			}
		>
			<Spin spinning={!enquiryDetail}>
				<EnquiryForm
					id="EditEnquiryForm"
					form={form}
					onFinish={handleSubmit}
					handleChange={handleChange}
				/>
			</Spin>
		</Modal>
	);
});

export default EditComponent;